import React from 'react';
import { observer } from 'mobx-react';
import StatisticsComponent from './Statistics.component';
import useStatistics from './useStatistics';
import { ICloseEvent } from '@core/interfaces/ICloseEvent';

const Container: React.FC<ICloseEvent> = ({ onClose }: ICloseEvent) => {
    const { values, lang } = useStatistics(onClose);

    return (
        <>
            <StatisticsComponent
                lang={lang.lang}
                login={values.login}
                groupsNumber={values.groupsNumber}
                devicesNumber={values.devicesNumber}
                lowChargeDevicesNumber={values.lowChargeDevicesNumber}
                longTimeNoContactDevicesNumber={
                    values.longTimeNoContactDevicesNumber
                }
                noTelemetryDevicesNumber={values.noTelemetryDevicesNumber}
                onClose={onClose}
            />
        </>
    );
};

const StatisticsContainer = observer(Container);

export default StatisticsContainer;
